import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Modal, Button, Row, Col, Alert } from "react-bootstrap";
import { Formik, Form } from "formik";
import * as Yup from "yup";

//Custom Hooks components
import FormSelect from "../../global/form/FormSelect";
import FieldInput from "../../global/form/FieldInput";
import ContentButton from "../../global/ContentButton";

/** services */
import {
  GetCollagesSchool,
  GetSchoolLevels,
  CreateProgram,
  GetCodeProgram,
  CollagesSchool,
} from "../../../api/Crm";

export default function ModalAddAcademicOffering(props) {
  const [t] = useTranslation(["global", "class"]);

  const [error, setError] = useState(false);
  const [collegesAndSchools, setCollegesAndSchools] = useState([]);
  const [higherLevels, setHigherLevels] = useState([]);
  const [initialFaculty, setInitialFaculty] = useState("");
  const [initialAcademicLevel, setInitialAcademicLevel] = useState("");
  const [showAdd, setShowAdd] = useState(false);

  let [typingCallback, setTypingCallback] = useState(null);

  const validationSchema = Yup.object().shape({
    faculty: Yup.object().required(
      t("class:modalAddAcademicOffering.faculty") +
        " " +
        t("class:classDetails.fieldRequired")
    ),
    academicLevel: Yup.object().required(
      t("class:modalAddAcademicOffering.academicLevel") +
        " " +
        t("class:classDetails.fieldRequired")
    ),
    careerName: Yup.string().required(
      t("class:modalAddAcademicOffering.careerName") +
        " " +
        t("class:classDetails.fieldRequired")
    ),
    code: Yup.string().required(
      t("class:modalAddAcademicOffering.key") +
        " " +
        t("class:classDetails.fieldRequired")
    ),
  });

  useEffect(() => {
    getCollegesAndSchools();
    getHigherLevels();
  }, []);

  const getCollegesAndSchools = () => {
    GetCollagesSchool()
      .then((response) => {
        if (response.status) {
          const formatData = response.data.map((college) => ({
            id: college.id,
            value: college.id,
            label: college.name,
          }));
          // insertar una opcion de ninguna al inicio
          formatData.unshift({
            id: "none",
            value: "none",
            label: t("class:modalAddAcademicOffering:none"),
          });

          setCollegesAndSchools(formatData);
          if (formatData.length > 0) {
            setInitialFaculty(formatData[0]);
          }
        }
      })
      .catch(() => {
        setError(t("global:messages.errorGeneral"));
      });
  };

  const getHigherLevels = () => {
    GetSchoolLevels().then((response) => {
      if (response.status) {
        const allLevels = response.data;
        let higher = allLevels.slice(6, allLevels.length);
        // TODO: filtro recuperado de CMv1
        higher = higher.filter(
          (level) => level.id >= 5 && level.id != 6 && level.id < 13
        );
        const formatData = higher.map((level) => ({
          id: level.id,
          value: level.id,
          label: level.name,
        }));
        setHigherLevels(formatData);
        if (formatData.length > 0) {
          setInitialAcademicLevel(formatData[0]);
        }
      }
    });
  };

  const createAcademicOffering = (payload) => {
    CreateProgram(payload).then((response) => {
      if (response.status) {
        props.setShowModalAddAcademicOffering(false);
      } else {
        setError(response.description);
      }
    });
  };

  const handleChageName = (name, setFieldValue) => {
    if (!name || name.length == 0) {
      return;
    }
    if (typingCallback) {
      clearTimeout(typingCallback);
    }
    typingCallback = setTimeout(() => {
      getCode(name, setFieldValue);
    }, 1000);
    setTypingCallback(typingCallback);
  };

  const getCode = (value, setFieldValue) => {
    const payload = {
      name: value,
    };
    GetCodeProgram(payload).then((response) => {
      if (response.status) {
        // Setear codigo sin perder el careerName ya escrito
        setFieldValue("code", response.data.code);
      }
    });
  };

  /**
   * create a new university faculty
   * @param {string} nameFaculty
   * @returns {JSON object} JSON object
   */
  const postCollagesSchool = async (nameFaculty) => {
    let data = {};
    data.name = nameFaculty.toUpperCase();
    return await CollagesSchool(data).then((result) => {
      if (result && result.description) {
        setError(result.description);
      } else {
        let data = result.data;
        setShowAdd(false);
        getCollegesAndSchools();
        let obj = {
          label: data.name,
          value: data.id,
        };
        return obj;
      }
    });
  };

  return (
    <Modal
      show={props.showModalAddAcademicOffering}
      aria-labelledby="contained-modal-title-lg"
      id="modalAddAcademicOffering"
    >
      <Modal.Header>
        <Modal.Title className="modal-title">
          {t("class:modalAddAcademicOffering.title")}
        </Modal.Title>
      </Modal.Header>
      <Formik
        enableReinitialize
        initialValues={{
          faculty: initialFaculty,
          academicLevel: initialAcademicLevel,
          careerName: "",
          code: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          let payload = {
            name: values.careerName,
            school_level_id: values.academicLevel.id,
            code: values.code,
          };
          if (values.faculty.id !== "none")
            payload.college_and_school_id = values.faculty.id;

          createAcademicOffering(payload);
        }}
      >
        {(formik) => (
          <Form>
            <Modal.Body>
              <Row>
                <Col md={12}>
                  {showAdd ? (
                    <div>
                      <FieldInput
                        name="nameFaculty"
                        type="text"
                        label={t("class:modalAddAcademicOffering.titleFaculty")}
                        capitalize={true}
                      />
                      <ContentButton className="content-button">
                        <Button
                          variant="outline-secondary"
                          onClick={() => setShowAdd(false)}
                        >
                          {t("global:buttons.cancel")}
                        </Button>
                        <Button
                          onClick={async () => {
                            let collageObj = await postCollagesSchool(
                              formik.values.nameFaculty
                            );
                            if (collageObj) {
                              formik.setFieldValue("nameFaculty", "");
                              formik.setFieldValue("faculty", collageObj);
                            }
                          }}
                          disabled={
                            formik.values.nameFaculty === "" ||
                            !formik.values.nameFaculty
                          }
                        >
                          {t("global:buttons.add")}
                        </Button>
                      </ContentButton>
                    </div>
                  ) : (
                    <div>
                      <FormSelect
                        id="faculty"
                        label={t("class:modalAddAcademicOffering.faculty")}
                        name="faculty"
                        options={collegesAndSchools}
                        onChange={(event) => {
                          formik.setFieldValue("faculty", event);
                        }}
                        value={formik.values.faculty}
                      />
                      <Col md={12}>
                        <p
                          style={{
                            fontFamily: "'Open Sans', sans-serif",
                            fontSize: "13px",
                            marginBottom: "5px",
                            textAlign: "right",
                          }}
                        >
                          <b>
                            {t("class:modalAddAcademicOffering.addFaculty")}
                          </b>
                          <i
                            value="add"
                            className="bi bi-plus-circle-fill"
                            style={{
                              alignContent: "center",
                              fontSize: "17px",
                              paddingTop: "11px",
                              color: "var(--red-primary)",
                              marginLeft: "4px",
                            }}
                            role="button"
                            onClick={() => setShowAdd(true)}
                          ></i>
                        </p>
                      </Col>
                    </div>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormSelect
                    id="academicLevel"
                    label={t("class:modalAddAcademicOffering.academicLevel")}
                    name="academicLevel"
                    options={higherLevels}
                    onChange={(event) => {
                      formik.setFieldValue("academicLevel", event);
                    }}
                    value={formik.values.academicLevel}
                  />
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <FieldInput
                    id="careerName"
                    label={t("class:modalAddAcademicOffering.careerName")}
                    placeholder={t("class:modalAddAcademicOffering.careerName")}
                    capitalize={true}
                    name="careerName"
                    type="text"
                    onChange={(e) => {
                      formik.setFieldValue("careerName", e.target.value);

                      // solo llamar getCode si el valor no es vacio y lleva 500 milisegundos sin cambiar
                      handleChageName(e.target.value, formik.setFieldValue);
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FieldInput
                    id="code"
                    label={t("class:modalAddAcademicOffering.key")}
                    placeholder={t("class:modalAddAcademicOffering.key")}
                    name="code"
                    type="text"
                  />
                </Col>
              </Row>

              {/* Show errors when creating or editing a matter */}
              {error && (
                <div className="mtop20">
                  <Alert variant="warning">{error}</Alert>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="outline-secondary"
                onClick={() => props.setShowModalAddAcademicOffering(false)}
              >
                {t("global:buttons.cancel")}
              </Button>
              <Button variant="primary" type="submit">
                {t("global:buttons:add")}
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}

ModalAddAcademicOffering.propTypes = {
  showModalAddAcademicOffering: PropTypes.bool,
  setShowModalAddAcademicOffering: PropTypes.func,

  collegesAndSchools: PropTypes.array,
};
